import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Layout({ children, user, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();
  // Update page title based on tenant
  useEffect(() => {
    if (user?.tenant_name) {
      document.title = user.tenant_name;
    }
  }, [user]);
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  const navLinkStyle = (path) => ({
    backgroundColor: isActive(path) ? '#3b82f6' : 'transparent',
    color: isActive(path) ? '#ffffff' : '#374151',
    padding: '12px 16px',
    borderRadius: '8px',
    display: 'block',
    textDecoration: 'none',
    marginBottom: '4px',
    transition: 'all 0.2s'
  });

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <div style={{
        width: '250px',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        padding: '24px 16px',
        position: 'fixed',
        height: '100vh',
        overflowY: 'auto'
      }}>
        {/* Logo / Brand */}
        <div style={{ marginBottom: '32px', paddingLeft: '12px' }}>
          <h1 style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827', margin: 0 }}>
            {user?.tenant_name || 'Valet Manager'}
          </h1>
          <p style={{ fontSize: '14px', color: '#6b7280', margin: '4px 0 0 0' }}>
            Management Dashboard
          </p>
        </div>

        {/* User Info */}
        {user && (
          <div style={{
            padding: '12px',
            backgroundColor: '#f3f4f6',
            borderRadius: '8px',
            marginBottom: '24px'
          }}>
            <p style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
              {user.first_name} {user.last_name}
            </p>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {user.role}
            </p>
          </div>
        )}

        {/* Main Navigation */}
        <nav>
          <p style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#9ca3af', 
            textTransform: 'uppercase', 
            letterSpacing: '0.05em',
            paddingLeft: '12px',
            marginBottom: '8px'
          }}>
            Dashboard
          </p>
          
          <Link to="/" style={navLinkStyle('/')}>
            🏠 Home
          </Link>
          <Link to="/live" style={navLinkStyle('/live')}>
            📊 Live Dashboard
          </Link>
          <Link to="/kpi" style={navLinkStyle('/kpi')}>
            📈 KPI Dashboard
          </Link>
          <Link to="/staffing" style={navLinkStyle('/staffing')}>
            👥 Staffing
          </Link>
          <Link to="/scheduling" style={navLinkStyle('/scheduling')}>
            📅 Scheduling
          </Link>
          <Link to="/templates" style={navLinkStyle('/templates')}>
            📋 Schedule Templates
          </Link>

          <p style={{ 
            fontSize: '12px', 
            fontWeight: '600', 
            color: '#9ca3af', 
            textTransform: 'uppercase', 
            letterSpacing: '0.05em',
            paddingLeft: '12px',
            marginTop: '24px',
            marginBottom: '8px'
          }}>
            Manage
          </p>
          
          <Link to="/locations" style={navLinkStyle('/locations')}>
            📍 Locations
          </Link>
          <Link to="/employees" style={navLinkStyle('/employees')}>
            🧑‍💼 Employees
          </Link>
          <Link to="/events" style={navLinkStyle('/events')}>
            🎉 Events
          </Link>
          <Link to="/control" style={navLinkStyle('/control')}>
            ⚙️ Control Center
          </Link>
        </nav>

        {/* Bottom Actions */}
        <div style={{ 
          position: 'absolute', 
          bottom: '24px', 
          left: '16px', 
          right: '16px' 
        }}>
          <Link 
            to="/employee-portal" 
            style={{
              display: 'block',
              padding: '12px 16px',
              backgroundColor: '#f3f4f6',
              borderRadius: '8px',
              textAlign: 'center',
              color: '#374151',
              textDecoration: 'none',
              fontSize: '14px',
              marginBottom: '8px'
            }}
          >
            🚗 Employee Portal
          </Link>

          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '12px 16px',
              backgroundColor: '#ef4444',
              borderRadius: '8px',
              textAlign: 'center',
              color: '#ffffff',
              border: 'none',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            🚪 Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={{
        marginLeft: '250px',
        flex: 1,
        backgroundColor: '#f9fafb',
        minHeight: '100vh'
      }}>
        {children}
      </div>
    </div>
  );
}

export default Layout;